import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAiOptInQuery } from "../api/aiChatApi";
import { type ExopenAiAccess, useExopenAiAccess } from "./useHasExopenAiAccess";

export function useAiChatAccess(companyDomainId: string): {
	hasAccess: boolean;
	access: ExopenAiAccess;
	optedIn: boolean;
	optedInAt: string | null;
	isLoading: boolean;
} {
	const access = useExopenAiAccess(companyDomainId);
	const hasAccess = access.allowed;
	const { data, isLoading } = useGetAiOptInQuery(
		hasAccess ? companyDomainId : skipToken,
	);

	return {
		hasAccess,
		access,
		optedIn: data?.optedIn ?? false,
		optedInAt: data?.optedInAt ?? null,
		isLoading: hasAccess && isLoading,
	};
}
